import React, { FC } from 'react';
import { Visibility as VisibilityIcon } from '@material-ui/icons';
import { StyledVisibilityIcon } from '../styledComponents';
import { MessageResultInterface } from './Interface';

export const MessageResult: FC<MessageResultInterface> = ({ onClick }: MessageResultInterface): JSX.Element => {
    return (
        <StyledVisibilityIcon>
            <VisibilityIcon
                onClick={(e): void => {
                    e.stopPropagation();
                    onClick();
                }}
            />
        </StyledVisibilityIcon>
    );
};
